import React from 'react';
import SectionHeader from '../../../components/SectionHeader';
import ProcessStep from './ProcessStep';
import './ProcessSection.css';

interface Step {
  number: string;
  title: string;
  description: string;
}

interface ProcessSectionProps {
  id?: string;
  title: string;
  subtitle: string;
  steps: Step[];
}

const ProcessSection: React.FC<ProcessSectionProps> = ({ id, title, subtitle, steps }) => {
  return (
    <section id={id} className="process-section">
      <div className="container">
        <SectionHeader title={title} subtitle={subtitle} />
        <div className="process-steps">
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              <ProcessStep {...step} />
              {index < steps.length - 1 && <div className="process-arrow">→</div>}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
